<a class="flex-row" [href]="url" target="_blank">
	<tvcore-icon class="u-m-right--xs text-black" name="file"></tvcore-icon>
	<span class="flex--1">
		<ng-content></ng-content>
	</span>
	<tvcore-icon class="u-m-left--xs text-blue" name="download"></tvcore-icon>
</a>
